module.exports = __webpack_public_path__ + "img/mind_file_icon.0c1a2cf9.svg";